import React from 'react';
import { Button } from 'react-bootstrap';

const CustomButton = ({title, onClick}) => {

  return (
    <Button onClick={onClick} className="gradient-button">
      {title}
    </Button>
  )

}

export default CustomButton;